import React from 'react';
import { ReactComponent as Location } from 'assets/icons/location-2.svg';
import { PartnerType } from 'models/partner.model';
import CopyText from 'components/base/copy-text';

type Props = {
  partner: PartnerType;
};
const PartnerBankDetails = ({ partner }: Props) => {
  const details = {
    bank: partner.payout_bank_name,
    acct_no: partner.payout_account_number,
    name: partner.payout_account_name
  };
  return (
    <div className='bg-[#F7F7F7] rounded-lg border-lg py-4'>
      <div className='flex flex-col xl:flex-row gap-2 justify-between mb-4 pl-4 pr-4'>
        <p>{details?.bank} </p>
        <CopyText text={details.acct_no} />
        <p className='text-current'>{details?.name} </p>
      </div>
      <hr className='font-light text-[#E8E8E8] border-[0.8px]' />
      <div className='mt-4 mb-2 flex justify-start items-center gap-3 pl-3 pr-4'>
        <Location />
        <p>{partner.address}</p>
      </div>
    </div>
  );
};

export default PartnerBankDetails;
